import Strutture from "../";

const routes = [
    { name: "StruttureList", path: "/strutture", component: Strutture.StruttureList, meta: { title: "strutture.lblTitle" } },
    { name: "StrutturaView", path: "/struttura/view/:id", component: Strutture.StrutturaView, meta: { title: "strutture.lblTitle" } },
    { name: "StrutturaEdit", path: "/struttura/edit/:id", component: Strutture.StrutturaEdit, meta: { title: "strutture.lblTitle" } },
];

export default routes;
